// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_3qyvB","expandedWidget":"FHpzA","mobile":"_2j-ok","floating":"mp5Tx","header":"_3xYPt","chatroom":"mG42G"};